// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delete-button[data-v-a18a0cb8]{width:2.6rem;height:2.6rem;position:absolute;top:-1.3rem;right:-1.3rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
